module.exports = __webpack_public_path__ + "audio/voice10.m4a";